export const load = url =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    const docHead = document.head || document.getElementsByTagName('head')[0];
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = url;
    script.id = 'HK_GMAP_SCRIPT';
    script.onload = resolve;
    script.onerror = reject;
    docHead.appendChild(script);
  });


export const isGoogleMapLoaded = () => {
    const isGoogleLoaded = typeof google !== 'undefined';
    const isGoogleMapsScriptInjected = document.querySelector('#HK_GMAP_SCRIPT');
    return isGoogleLoaded || isGoogleMapsScriptInjected;
  };